export default __webpack_public_path__ + "static/media/051-cylinder.ab4992e2.svg";